// @ts-check
import React from 'react';
import { getStudentDisplayName } from '../../../config/studentNameMapping';
import './AccountSwitcher.css';

const AVATAR_COLORS = [
  'linear-gradient(145deg, #a8c99e 0%, #87a878 100%)',
  'linear-gradient(145deg, #8bb8d0 0%, #6a9cb8 100%)',
  'linear-gradient(145deg, #d0a8c9 0%, #b887a8 100%)',
  'linear-gradient(145deg, #d0c4a8 0%, #b8a887 100%)',
  'linear-gradient(145deg, #a8b8d0 0%, #8798b8 100%)',
];

/**
 * Account Switcher - displays family members for one-tap switching.
 * Returns null if no family members (zero UI change for solo users).
 *
 * @param {Object} props
 * @param {Array<{ authing_user_id: string, display_name: string | null, role: string }>} props.familyMembers
 * @param {string} props.currentStudentId
 * @param {(id: string) => void} props.onSwitchAccount
 */
function AccountSwitcher({ familyMembers, currentStudentId, onSwitchAccount }) {
  if (!familyMembers || familyMembers.length === 0) {
    return null;
  }

  return (
    <div className="account-switcher-section">
      <h3 className="account-switcher-title">切换账号</h3>
      <div className="account-switcher-list">
        {familyMembers.map((member, index) => {
          const isActive = member.authing_user_id === currentStudentId;
          const displayName = member.display_name || getStudentDisplayName(member.authing_user_id);
          const initial = displayName.charAt(0).toUpperCase();
          const avatarColor = AVATAR_COLORS[index % AVATAR_COLORS.length];

          return (
            <button
              key={member.authing_user_id}
              className={`account-switcher-item${isActive ? ' active' : ''}`}
              onClick={() => !isActive && onSwitchAccount(member.authing_user_id)}
              type="button"
            >
              <div
                className="account-switcher-avatar"
                style={{ background: avatarColor }}
              >
                {initial}
              </div>
              <span className="account-switcher-name">{displayName}</span>
              {isActive && <span className="account-switcher-badge">当前</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default AccountSwitcher;
